// import { createApp } from 'vue'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import globalMixin from './mixins/global'
import Toasted from 'vue-toasted'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
// import firebase from './firebase'
// import messaging from './messaging_init_in_sw'
// Vue.use(messaging)
Vue.use(Toasted, {
  position: 'bottom-center',
  duration: 5000,
})

Vue.mixin(globalMixin)

Vue.prototype.$EventBus = new Vue()

new Vue({
  router,
  // firebase,
  // messaging,
  render: h => h(App),

  beforeCreate() {
    Vue.$store = this.$store
    Vue.$router = this.$router
    Vue.$route = this.$route
    Vue.$toasted = this.$toasted
    Vue.$set = this.$set
  },
}).$mount('#app')
